import script from "./LiveEsportSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveEsportSlider.vue?vue&type=script&setup=true&lang=js"

import "./LiveEsportSlider.vue?vue&type=style&index=0&id=3cd5d4e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd5d4e8"]])

export default __exports__